module.exports = __webpack_public_path__ + "img/person-dash.80620cea.svg";